/* c8 ignore start */
import { i18n } from "@/i18n.js";
import { SIDENAV_GROUP_BY } from "@/constants";
import { WEBFILTERING_SERVICE } from "@/utils/services";

export const MSP_NAV_ITEMS = [
  {
    //
    //
    // keeping it here to when it's ready
    //
    //
    // order: 3,
    // groupBy: SIDENAV_GROUP_BY.BETA,
    // label: i18n.global.t("sidebar-web-filtering"),
    // name: "msp-web_filtering",
    // icon: "cl-icon-tabler-world",
    // id: "/msp/web_filtering",
    // dataTestId: "msp-web_filtering",
    // isExternal: true,
    // disabled: true,
    // permanentPill: {
    //   variant: "success",
    //   text: i18n.global.t("status-coming-soon"),
    // },
    // externalLink: "https://www.titanhq.com/web-filtering-ui/",
    // children: [
    //   {
    //     label: i18n.global.t("sidebar-overview"),
    //     id: "/msp/web_filtering/overview",
    //     dataTestId: "msp-web_filtering-overview",
    //   },
    // ],
  },
];

const webFilteringNavItems = [
  {
    label: i18n.global.t("sidebar-overview"),
    id: "/customer/web_filtering/overview",
    dataTestId: "customer-web_filtering-overview",
  },
];

export const CUSTOMER_NAV_ITEMS = [
  {
    order: 3,
    groupBy: SIDENAV_GROUP_BY.BETA,
    label: i18n.global.t("sidebar-web-filtering"),
    icon: "cl-icon-tabler-world",
    id: "/customer/web_filtering",
    dataTestId: "customer-web_filtering",
    solutionId: WEBFILTERING_SERVICE,
    children: webFilteringNavItems,
  },
];
/* c8 ignore end */
